const wrapperCls = "_61w1n12fir";

export { wrapperCls };
import "./atom.filters.style.linaria.module.css";
//# sourceMappingURL=atom.filters.style.js.map
